import { QueryKey, queryOptions, useQuery } from '@tanstack/react-query'
import {
  GetMccGroupCatalogueResponse,
  GetMccGroupListResponse,
  MccGroupCatalogue,
  MccGroupListModel,
  MccGroupListResponse,
} from 'src/models/mccGroup.models'
import { getMccGroups } from 'src/queries/mccGroups.network'
import { MCC_GROUPS_QK } from 'src/queries/queries.constants'
import { ExtendBaseQueryOptions } from 'src/queries/queries.utils'

export type { GetMccGroupListResponse } from 'src/models/mccGroup.models'

export const mccGroupsQueries = {
  list: (additionalKey?: string) => {
    const queryKey: QueryKey = additionalKey
      ? [MCC_GROUPS_QK, additionalKey]
      : [MCC_GROUPS_QK]

    return queryOptions({
      queryKey,
      queryFn: () => getMccGroups(),
    })
  },
  cardManagementCatalogue: () =>
    queryOptions({
      queryKey: [MCC_GROUPS_QK, 'card-management-catalogue'],
      queryFn: async (): Promise<MccGroupCatalogue[]> => {
        const response = await getMccGroups<GetMccGroupCatalogueResponse>({
          includeRanges: true,
        })
        return response.mccGroups
      },
    }),
}

interface UseQueryMccGroupsProps
  extends ExtendBaseQueryOptions<GetMccGroupListResponse, MccGroupListModel[]> {
  additionalKey?: string
}

export const useQueryMccGroups = (props: UseQueryMccGroupsProps = {}) => {
  const { additionalKey, queryCacheOptions, ...rest } = props

  return useQuery({
    ...mccGroupsQueries.list(additionalKey),
    select: (data: GetMccGroupListResponse) =>
      data?.mccGroups.map(
        (mcc: MccGroupListResponse) => new MccGroupListModel(mcc),
      ),
    ...queryCacheOptions,
    ...rest,
  })
}
